export const getApprovals = (state: $TSMigrationFixMe) => {
  const { aprobaciones } = state.aprobaciones

  return aprobaciones
}

export const getApprovalItem = (state: $TSMigrationFixMe) => {
  const { aprobacionItem } = state.aprobaciones
  return aprobacionItem
}
export const getApprovalStatus = (state: $TSMigrationFixMe) => {
  const { aprobacionesStatus } = state.aprobaciones
  return aprobacionesStatus
}
